import PropTypes from 'prop-types';
import { useTheme } from '@material-ui/core/styles';
import Label from 'src/components/Label';
import {
  getEstimateJobStageFromRow,
  STAGE_COLORS,
  STAGE_LABELS,
} from 'src/pages/dashboard/EstimateCalendar';

export default function EstimateJobStageLabel({ row, variant, sx }) {
  const theme = useTheme();
  if (Number(row?.quotation_status) === 12) {
    return (
      <Label
        variant={variant ?? (theme.palette.mode === 'light' ? 'ghost' : 'filled')}
        color="error"
        sx={sx}
      >
        Void
      </Label>
    );
  }
  const stage = getEstimateJobStageFromRow(row);
  const stageColor = STAGE_COLORS[stage] || STAGE_COLORS.New;

  return (
    <Label
      variant={variant ?? (theme.palette.mode === 'light' ? 'ghost' : 'filled')}
      sx={{
        bgcolor: stageColor,
        color: '#fff',
        ...sx,
      }}
    >
      {STAGE_LABELS[stage] || STAGE_LABELS.New}
    </Label>
  );
}

EstimateJobStageLabel.propTypes = {
  row: PropTypes.object.isRequired,
  variant: PropTypes.string,
  sx: PropTypes.object,
};
